"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PointsStyle = exports.NewHandgradingRubricData = exports.HandgradingRubric = exports.HandgradingRubricCoreData = void 0;
var annotation_1 = require("./annotation");
var criterion_1 = require("./criterion");
var http_client_1 = require("./http_client");
var utils_1 = require("./utils");
var HandgradingRubricCoreData = /** @class */ (function () {
    function HandgradingRubricCoreData(args) {
        this.pk = args.pk;
        this.project = args.project;
        this.last_modified = args.last_modified;
        this.points_style = args.points_style;
        this.max_points = args.max_points;
        this.show_grades_and_rubric_to_students = args.show_grades_and_rubric_to_students;
        this.show_only_applied_rubric_to_students = args.show_only_applied_rubric_to_students;
        this.handgraders_can_leave_comments = args.handgraders_can_leave_comments;
        this.handgraders_can_adjust_points = args.handgraders_can_adjust_points;
    }
    return HandgradingRubricCoreData;
}());
exports.HandgradingRubricCoreData = HandgradingRubricCoreData;
var HandgradingRubric = /** @class */ (function (_super) {
    __extends(HandgradingRubric, _super);
    function HandgradingRubric(args) {
        var _this = _super.call(this, args) || this;
        _this.criteria = args.criteria.map(function (item) { return new criterion_1.Criterion(item); });
        _this.annotations = args.annotations.map(function (item) { return new annotation_1.Annotation(item); });
        return _this;
    }
    HandgradingRubric.subscribe = function (observer) {
        HandgradingRubric._subscribers.add(observer);
    };
    HandgradingRubric.unsubscribe = function (observer) {
        HandgradingRubric._subscribers.delete(observer);
    };
    HandgradingRubric.get_from_project = function (project_pk) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/projects/" + project_pk + "/handgrading_rubric/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new HandgradingRubric(response.data)];
                }
            });
        });
    };
    HandgradingRubric.get_by_pk = function (handgrading_rubric_pk) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/handgrading_rubrics/" + handgrading_rubric_pk + "/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new HandgradingRubric(response.data)];
                }
            });
        });
    };
    HandgradingRubric.create = function (project_pk, data) {
        return __awaiter(this, void 0, void 0, function () {
            var response, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().post("/projects/" + project_pk + "/handgrading_rubric/", data)];
                    case 1:
                        response = _a.sent();
                        result = new HandgradingRubric(response.data);
                        HandgradingRubric.notify_handgrading_rubric_created(result);
                        return [2 /*return*/, result];
                }
            });
        });
    };
    HandgradingRubric.import_from_project = function (import_to_project_pk, import_from_project_pk) {
        return __awaiter(this, void 0, void 0, function () {
            var response, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().post("/projects/" + import_to_project_pk
                            + ("/import_handgrading_rubric_from/" + import_from_project_pk + "/"))];
                    case 1:
                        response = _a.sent();
                        result = new HandgradingRubric(response.data);
                        HandgradingRubric.notify_handgrading_rubric_created(result);
                        return [2 /*return*/, result];
                }
            });
        });
    };
    HandgradingRubric.notify_handgrading_rubric_created = function (handgrading_rubric) {
        var e_1, _a;
        try {
            for (var _b = __values(HandgradingRubric._subscribers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscriber = _c.value;
                subscriber.update_handgrading_rubric_created(handgrading_rubric);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    HandgradingRubric.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().patch("/handgrading_rubrics/" + this.pk + "/", utils_1.filter_keys(this, HandgradingRubric.EDITABLE_FIELDS))];
                    case 1:
                        response = _a.sent();
                        utils_1.safe_assign(this, new HandgradingRubric(response.data));
                        HandgradingRubric.notify_handgrading_rubric_changed(this);
                        return [2 /*return*/];
                }
            });
        });
    };
    HandgradingRubric.prototype.refresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            var last_modified, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        last_modified = this.last_modified;
                        return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/handgrading_rubrics/" + this.pk + "/")];
                    case 1:
                        response = _a.sent();
                        utils_1.safe_assign(this, new HandgradingRubric(response.data));
                        if (last_modified !== this.last_modified) {
                            HandgradingRubric.notify_handgrading_rubric_changed(this);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    HandgradingRubric.notify_handgrading_rubric_changed = function (handgrading_rubric) {
        var e_2, _a;
        try {
            for (var _b = __values(HandgradingRubric._subscribers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscriber = _c.value;
                subscriber.update_handgrading_rubric_changed(handgrading_rubric);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    HandgradingRubric.prototype.delete = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().delete("/handgrading_rubrics/" + this.pk + "/")];
                    case 1:
                        _a.sent();
                        HandgradingRubric.notify_handgrading_rubric_deleted(this);
                        return [2 /*return*/];
                }
            });
        });
    };
    HandgradingRubric.notify_handgrading_rubric_deleted = function (handgrading_rubric) {
        var e_3, _a;
        try {
            for (var _b = __values(HandgradingRubric._subscribers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscriber = _c.value;
                subscriber.update_handgrading_rubric_deleted(handgrading_rubric);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    HandgradingRubric._subscribers = new Set();
    HandgradingRubric.EDITABLE_FIELDS = [
        'points_style',
        'max_points',
        'show_grades_and_rubric_to_students',
        'show_only_applied_rubric_to_students',
        'handgraders_can_leave_comments',
        'handgraders_can_adjust_points',
    ];
    return HandgradingRubric;
}(HandgradingRubricCoreData));
exports.HandgradingRubric = HandgradingRubric;
var NewHandgradingRubricData = /** @class */ (function () {
    function NewHandgradingRubricData(_a) {
        var points_style = _a.points_style, max_points = _a.max_points, show_grades_and_rubric_to_students = _a.show_grades_and_rubric_to_students, show_only_applied_rubric_to_students = _a.show_only_applied_rubric_to_students, handgraders_can_leave_comments = _a.handgraders_can_leave_comments, handgraders_can_adjust_points = _a.handgraders_can_adjust_points;
        this.points_style = points_style;
        this.max_points = max_points;
        this.show_grades_and_rubric_to_students = show_grades_and_rubric_to_students;
        this.show_only_applied_rubric_to_students = show_only_applied_rubric_to_students;
        this.handgraders_can_leave_comments = handgraders_can_leave_comments;
        this.handgraders_can_adjust_points = handgraders_can_adjust_points;
    }
    return NewHandgradingRubricData;
}());
exports.NewHandgradingRubricData = NewHandgradingRubricData;
var PointsStyle;
(function (PointsStyle) {
    PointsStyle["start_at_zero_and_add"] = "start_at_zero_and_add";
    PointsStyle["start_at_max_and_subtract"] = "start_at_max_and_subtract";
})(PointsStyle = exports.PointsStyle || (exports.PointsStyle = {}));
//# sourceMappingURL=handgrading_rubric.js.map